const ComplianceLEED = () => {
  return "compliance leed not implemented";
};
export default ComplianceLEED;
